import { t } from 'shared/locale/texts';
import type { Vertical } from '@/data/verticals';

export const createHeading = (vertical: Vertical, destination: string) => {
    const prefix = t(`heading.${vertical}.prefix`);
    const suffix = destination ? t(`heading.${vertical}.preposition`, { destination }) : t('heading.postfix');

    return `${prefix} ${suffix}`;
};
